import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class ReasonService extends CrudService {
  constructor() {
    super(API_RESOURCE.REASON_CONFIG)
  }

  fetchReasonsByType = async (type) => {
    const response = await axios.get(`${this.resource}/type/${type}`)

    const resObject = response?.data

    if (resObject?.data && resObject?.success) {
      return resObject.data.results
    }
    return response.data
  }

  updateReason = async ({ type, data }) => {
    const response = await axios.put(`${this.resource}/type/${type}`, data)
    return response.data
  }
}

export default ReasonService
